import moment from 'moment-timezone'

export default {
  state: {
    setting_context: false,
    store_id_url: undefined,
  },
  getters: {
    storeIdURL: state => state.store_id_url,
    getStoreByURL: (state, getters) => {
      if (state.store_id_url) {
        // return getters.make_slug_to_data('store', state.store_id_url)
        return getters.all_stores.find(
          store =>
            store.website_slug === state.store_id_url ||
            store._id === state.store_id_url
        )
      }
    },

    currentStoreSlug: (state, getters) =>
      state.current_store
        ? getters.set_website_slug(state.current_store)
        : undefined,

    contextSettingInProgress: state => state.setting_context,
    make_slug_to_data: (state, getters) => (slug_from, slug = undefined) => {
      /*will optimise later, will do with store slug in a place, will take it from there*/
      let data_from = ''
      if (slug_from === 'store')
        data_from = getters.all_stores.find(
          store => getters.set_website_slug(store) == slug
        )
      if (slug_from === 'brand')
        data_from = getters.all_brands.find(
          brand => getters.set_website_slug(brand) == slug
        )
      if (slug_from === 'category') data_from = getters.selected_category
      if (slug_from === 'sub_category') data_from = getters.sub_categories
      // if (slug_from === 'item') data_from = getters.item
      return data_from
    },
    storeDAforCustomerAddress: (state, getters) => {
      if (getters.customer_address) {
        var found_area = getters.all_store_delivery_areas.find(
          item =>
            item.store_id == getters.currentStoreId &&
            item.delivery_area == getters.customer_address.delivery_area_id
        )
        if (found_area) return found_area
        var city_da_arr = getters.customer_address.delivery_area_id.split('|')
        var city_da =
          city_da_arr[1] + '|' + city_da_arr[1] + '|' + city_da_arr[2]
        var city_area = getters.all_store_delivery_areas.find(
          item =>
            item.store_id == getters.currentStoreId &&
            item.delivery_area == city_da
        )
        if (city_area) return city_area
      }
      return undefined
    },
    deliveryTime: (state, getters) => (store, is_future_time = false) => {
      let format_time = ''
      let future_time = 0
      let ante = ''
      if (store) {
        ante = store.delivery_duration.split(' ')
        format_time = store.delivery_duration.split(':')
        let delivery_time = ''
        if (parseInt(format_time[0]) > 0) {
          delivery_time =
            format_time[0] +
            ' ' +
            (parseInt(format_time[0]) > 1
              ? getters._T('Days')
              : getters._T('Day'))
          future_time += parseInt(format_time[0]) * 60 * 24
        }
        if (parseInt(format_time[1]) > 0) {
          delivery_time +=
            ' ' +
            format_time[1] +
            ' ' +
            (parseInt(format_time[1]) > 1
              ? getters._T('Hours')
              : getters._T('Hour'))
          future_time += parseInt(format_time[1]) * 60
        }
        if (parseInt(format_time[2]) > 0) {
          delivery_time +=
            ' ' +
            format_time[2] +
            ' ' +
            (parseInt(format_time[2]) > 1
              ? getters._T('Minutes')
              : getters._T('Minute'))
          future_time += parseInt(format_time[2])
        }
        if (typeof ante[1] != undefined) {
          if (ante === 'AM') {
            //
          } else {
            //
          }
        }
        return is_future_time ? future_time : delivery_time
      }
      return is_future_time ? future_time : format_time
    },
    delivery_available: (state, getters) => {
      let nextDay = false
      let data = {
        available: false,
        nextDay: nextDay,
        open: '00',
        close: '00',
        deliveryTime: {
          hours: 0,
          mins: 0,
          days: 0,
        },
      }

      if (getters.currentStore) {
        const deliverySchedule = getters.currentStore.delivery_hours
        const [
          days,
          hours,
          mins,
        ] = getters.currentStore.delivery_duration.split(':')

        data.open = deliverySchedule.opens_at
        data.close = deliverySchedule.closes_at
        data.deliveryTime.hours = hours
        data.deliveryTime.mins = mins
        data.deliveryTime.days = days

        if (deliverySchedule.all_day_long || data.open == data.close) {
          data.available = true
          return data
        }

        const nowTime = moment().utc()

        const deliveryTimeInSeconds =
          parseInt(days) * 24 * 60 * 60 +
          parseInt(hours) * 60 * 60 +
          parseInt(mins) * 60

        const SecondsToAlertBeforeDeliveryClose = 0 //convert 30 mins into seconds
        const storeTimezone = getters.selectedTimezone

        const deliveryTimeRequired = moment()
          .add(
            deliveryTimeInSeconds + SecondsToAlertBeforeDeliveryClose,
            'seconds'
          )
          .utc()

        const deliveryOpenTimeUtc = moment
          .tz(deliverySchedule.opens_at, 'HH:mm', storeTimezone)
          .utc()
        let deliveryCloseTimeUtc = moment
          .tz(deliverySchedule.closes_at, 'HH:mm', storeTimezone)
          .utc()

        nextDay = deliveryCloseTimeUtc.isBefore(deliveryOpenTimeUtc, 'seconds')
        // //check if the close time lyes in next day
        if (nextDay) {
          deliveryCloseTimeUtc = moment
            .tz(deliverySchedule.closes_at, 'HH:mm', storeTimezone)
            .add(1, 'day')
            .utc()
        }
        if (deliveryTimeRequired.isBetween(nowTime, deliveryCloseTimeUtc)) {
          data.available = true
          data.nextDay = nextDay
          return data
        }
      }

      return data
    },
  },
  actions: {
    // setStore: async ({ commit, getters }, { store_id }) => {
    //   return new Promise((resolve, reject) => {
    //     commit('START_SETTING_CONTEXT')
    //     if (store_id) {
    //       var store = getters.find_brand_store_by_main_id(store_id)
    //       if (!store) {
    //         store = getters.make_slug_to_data('store', store_id)
    //       }
    //       if (store) {
    //         commit('SET_CURRENT_STORE', store)
    //         resolve()
    //       } else {
    //         reject()
    //       }
    //     } else {
    //       //only brand present, no store
    //       resolve()
    //     }
    //     commit('FINISH_SETTING_CONTEXT')
    //   })
    // },
  },
  mutations: {
    SET_STORE_ID_URL: (state, store_id) => {
      state.store_id_url = store_id
      //state.is_store_brand = store
    },
    SET_CURRENT_STORE: (state, store) => {
      state.current_store = store
      //state.is_store_brand = store
    },
    START_SETTING_CONTEXT: state => (state.setting_context = true),
    FINISH_SETTING_CONTEXT: state => (state.setting_context = false),
  },
}
